var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuildingNewX2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 8.99998C14 8.4477 14.4477 7.99998 15 7.99998H17C17.5523 7.99998 18 8.4477 18 8.99998C18 9.55227 17.5523 9.99998 17 9.99998H15C14.4477 9.99998 14 9.55227 14 8.99998Z",
    className: "Icon-fill-color"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.99998C9.44772 7.99998 9 8.4477 9 8.99998C9 9.55227 9.44772 9.99998 10 9.99998H12C12.5523 9.99998 13 9.55227 13 8.99998C13 8.4477 12.5523 7.99998 12 7.99998H10Z",
    className: "Icon-fill-color"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11.5C14 10.9477 14.4477 10.5 15 10.5H17C17.5523 10.5 18 10.9477 18 11.5C18 12.0523 17.5523 12.5 17 12.5H15C14.4477 12.5 14 12.0523 14 11.5Z",
    className: "Icon-fill-color"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.5C9.44772 10.5 9 10.9477 9 11.5C9 12.0523 9.44772 12.5 10 12.5H12C12.5523 12.5 13 12.0523 13 11.5C13 10.9477 12.5523 10.5 12 10.5H10Z",
    className: "Icon-fill-color"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6.69998C14 6.1477 14.4477 5.69998 15 5.69998H17C17.5523 5.69998 18 6.1477 18 6.69998C18 7.25227 17.5523 7.69998 17 7.69998H15C14.4477 7.69998 14 7.25227 14 6.69998Z",
    className: "Icon-fill-color"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1708 0.734512C19.4951 0.131102 21 1.09916 21 2.55451V21C21.5523 21 22 21.4477 22 22C22 22.5523 21.5523 23 21 23H3C2.44772 23 2 22.5523 2 22C2 21.4477 2.44772 21 3 21V14.2141C3 12.9558 4.14824 12.01 5.38329 12.2512L6 12.3716V7.56634C6 6.7827 6.45766 6.07126 7.17077 5.74635L18.1708 0.734512ZM13 21H16V16.3621L5 14.2141V21H8V19C8 17.8954 8.89543 17 10 17H11C12.1046 17 13 17.8954 13 19V21ZM11 21V19H10V21H11ZM18 21H19V2.55451L8 7.56634V12.7622L16.3833 14.3991C17.3223 14.5825 18 15.4053 18 16.3621V21Z",
    className: "Icon-fill-color"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingNewX2);
export default __webpack_public_path__ + "static/media/BuildingNewX2.a85b081f2c8a8bc8d792d0d8b156e4f0.svg";
export { ForwardRef as ReactComponent };